(() => {
  const SELECTORS = {
    section: '.product-display-section',
    swiper: '.product-display-swiper',
    scrollbar: '.product-display-scrollbar',
    prev: '.product-display-arrow--prev',
    next: '.product-display-arrow--next',
    cardLinks: '.js-product-card-link'
  };

  const DRAG_THRESHOLD = 8;
  const INTERACTIVE_SELECTOR = 'button, input, select, textarea, label, form, a';

  const toggleSectionState = (swiper) => {
    const section = swiper.el.closest(SELECTORS.section);

    if (!section) {
      return;
    }

    section.classList.toggle('is-swiper-locked', swiper.isLocked);
  };

  const bindCardNavigation = (section) => {
    const cardLinks = section.querySelectorAll(SELECTORS.cardLinks);

    cardLinks.forEach((cardLink) => {
      if (cardLink.dataset.cardNavBound === 'true') {
        return;
      }

      cardLink.dataset.cardNavBound = 'true';

      let startX = 0;
      let startY = 0;
      let moved = false;
      let pointerDown = false;

      const onStart = (x, y) => {
        startX = x;
        startY = y;
        moved = false;
        pointerDown = true;
      };

      const onMove = (x, y) => {
        if (!pointerDown) {
          return;
        }

        const deltaX = Math.abs(x - startX);
        const deltaY = Math.abs(y - startY);

        if (deltaX > DRAG_THRESHOLD || deltaY > DRAG_THRESHOLD) {
          moved = true;
        }
      };

      const onEnd = () => {
        pointerDown = false;
      };

      cardLink.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }

        onStart(event.clientX, event.clientY);
      });

      cardLink.addEventListener('pointermove', (event) => {
        onMove(event.clientX, event.clientY);
      });

      cardLink.addEventListener('pointerup', onEnd);
      cardLink.addEventListener('pointercancel', onEnd);

      cardLink.addEventListener('click', (event) => {
        const interactiveTarget = event.target.closest(INTERACTIVE_SELECTOR);

        if (interactiveTarget && interactiveTarget !== cardLink) {
          return;
        }

        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const url = cardLink.dataset.productUrl;

        if (url) {
          window.location.href = url;
        }
      });

      cardLink.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();

        const url = cardLink.dataset.productUrl;

        if (url) {
          window.location.href = url;
        }
      });
    });
  };

  const bindNativeDragPrevention = (section) => {
    if (section.dataset.nativeDragBound === 'true') {
      return;
    }

    section.dataset.nativeDragBound = 'true';

    section.addEventListener('dragstart', (event) => {
      if (
        event.target.closest(
          '.product-display-card__image, .product-display-card__image-link, .js-product-card-link'
        )
      ) {
        event.preventDefault();
      }
    });
  };

  const initProductDisplaySwiper = (scope = document) => {
    const sections = scope.matches?.(SELECTORS.section)
      ? [scope]
      : scope.querySelectorAll(SELECTORS.section);

    sections.forEach((section) => {
      const swiperEl = section.querySelector(SELECTORS.swiper);
      const scrollbarEl = section.querySelector(SELECTORS.scrollbar);
      const prevEl = section.querySelector(SELECTORS.prev);
      const nextEl = section.querySelector(SELECTORS.next);

      if (!swiperEl || !scrollbarEl || !prevEl || !nextEl) {
        return;
      }

      bindCardNavigation(section);
      bindNativeDragPrevention(section);

      if (swiperEl.swiper) {
        swiperEl.swiper.update();
        toggleSectionState(swiperEl.swiper);
        return;
      }

      new Swiper(swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        speed: 600,
        threshold: 8,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,

        noSwiping: true,
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: 'button, input, select, textarea, label, form',

        preventClicks: true,
        preventClicksPropagation: true,
        touchStartPreventDefault: false,

        navigation: {
          prevEl,
          nextEl
        },

        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          hide: false
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true
        },

        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous products',
          nextSlideMessage: 'Next products'
        },

        breakpoints: {
          480: {
            slidesPerView: 1.35,
            spaceBetween: 14
          },
          576: {
            slidesPerView: 1.6,
            spaceBetween: 14
          },
          768: {
            slidesPerView: 2.15,
            spaceBetween: 16
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 18
          },
          1200: {
            slidesPerView: 3.5,
            spaceBetween: 18
          }
        },

        on: {
          init(swiper) {
            toggleSectionState(swiper);
          },
          resize(swiper) {
            toggleSectionState(swiper);
          },
          breakpoint(swiper) {
            toggleSectionState(swiper);
          },
          update(swiper) {
            toggleSectionState(swiper);
          }
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initProductDisplaySwiper();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initProductDisplaySwiper(event.target);
  });

  document.addEventListener('shopify:section:reorder', (event) => {
    initProductDisplaySwiper(event.target);
  });
})();